import React from 'react';

interface PaymentProviderProps {
  children: React.ReactNode;
}

/**
 * Payment Provider Component
 * Provides payment context to child components
 * Now uses Razorpay instead of Stripe
 */
export function PaymentProvider({ children }: PaymentProviderProps) {
  // Razorpay script is loaded dynamically in the service
  // This component is kept for consistency and future features
  return <>{children}</>;
}

/**
 * Razorpay Provider Component
 * Direct export for Razorpay-specific usage
 */
export function RazorpayProvider({ children }: PaymentProviderProps) {
  return <PaymentProvider>{children}</PaymentProvider>;
}

// Legacy export for backward compatibility during migration
export function StripeProvider({ children }: PaymentProviderProps) {
  console.warn('StripeProvider is deprecated. Payment system now uses Razorpay.');
  return <PaymentProvider>{children}</PaymentProvider>;
}

// Default export
export default PaymentProvider;
